module.exports = __webpack_public_path__ + "static/boy-1-8e0a3f76230028b848f5a66711f07c4b.jpg";